<template>
	<div class="emoticon-wrap" :class="{'other': resizeLayer, 'hidden': hiddenFlag}" v-click-outside="onClickOutside" 
		:style="{top: location.top + 'px', left: location.left + 'px' }">
		<!-- <p class="emoticon-wrap-title">{{ $i18nUtil.trans("title.EmoticonSelector.001", "이모티콘 등록") }}</p> -->
		<!-- <swiper :options="swiperOption" ref="myEMSwiper" class="em-swiper">
				<swiper-slide v-for="category in result.categoryList" :key="category.categoryId">
					<button type="button" @click="selectedCat = category">{{ category.CATEGORY_NAME.substring(0, 2) }}</button>
				</swiper-slide>
				<div class="swiper-button-prev" slot="button-prev">prev</div>
				<div class="swiper-button-next" slot="button-next">next</div>
		</swiper> -->
		<div class="scroll"> <!-- v-if="selectedCat === null" -->
			<div class="emoticon-box" v-for="(res, categoryId) in result.catEmoticonList" :key="categoryId = res.category.CATEGORY_ID">
				<!-- <p class="emoticon-title" v-show="result.catEmoticonList.length > 1">{{ res.category.CATEGORY_NAME }}</p> -->
				<ul class="emoticon-list">
					<li v-for="emoticon in res[categoryId]" :key="emoticon.emoticonId" :id="emoticon.emoticonId"
						@click="onSelectImage(emoticon)"
						@dblclick="registDblclick(emoticon)"
					>
						<p class="em-tit">{{ $i18nUtil.getLanguage() === 'en' ? emoticon.emoticonNameEn : emoticon.emoticonName }}</p>
						<img :src="$emoticonFn.getEmoticonSrc(emoticon.tenantId, emoticon.select)">
					</li>
				</ul>
			</div>
		</div>
		<!-- <div class="scroll" v-if="selectedCat !== null">
			<div class="emoticon-box">
				<ul class="emoticon-list">
					<li v-for="emoticon in selectedList" :key="emoticon.emoticonId" :id="emoticon.emoticonId"
						@click="onSelectImage(emoticon)"
						@dblclick="registDblclick(emoticon)"
					>
						<p class="em-tit">{{ $i18nUtil.getLanguage() === 'en' ? emoticon.emoticonNameEn : emoticon.emoticonName }}</p>
						<img :src="$emoticonFn.getEmoticonSrc(emoticon.tenantId, emoticon.select)">
					</li>
				</ul>
			</div>
		</div> -->
		<div class="btn_box txtr" v-if="type == 'add' || this.type == 'addReply' && txtAddEmoticon">
			<button type="button" class="btn-txt-primary" @click="cancel">{{ $i18nUtil.trans("button.cancel", "취소") }}</button>
			<button type="button" class="btn-txt-primary" :class="selected == null ? '' : 'black'" 
				@click="add" :disabled="selected == null"
			>{{ $i18nUtil.trans("button.register", "등록") }}</button>
		</div>
		<div class="btn_box txtr" v-if="(type == 'addUpdate' || this.type == 'replyUpdate')&& txtAddEmoticon">
			<button type="button" class="btn-txt-primary" @click="cancel">{{ $i18nUtil.trans("button.cancel", "취소") }}</button>
			<button type="button" class="btn-txt-primary" :class="selected == null ? '' : 'black'" 
				@click="addUpdate" :disabled="selected == null"
			>수정{{ $i18nUtil.trans("button.register", "등록") }}</button>
		</div>
		<div class="btn_box txtr" v-if="type == 'regist' && !txtAddEmoticon">
			<button type="button" class="btn-txt-primary" @click="cancel">{{ $i18nUtil.trans("button.cancel", "취소") }}</button>
			<button type="button" class="btn-txt-primary" :class="selected == null ? '' : 'black'" 
				@click="regist" :disabled="selected == null"
			>{{ $i18nUtil.trans("button.register", "등록") }}</button>
		</div>
	</div>
</template>

<script>
import EventBus from "@/js/eventbus/eventBus";
import { $ } from "dom7";
import clickOutside from "v-click-outside";
import { mapActions } from "vuex";

// import Vue from 'vue'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.use(VueAwesomeSwiper, /* { default global options } */)
// // Navigation error로 아래 내용으로 대체
// import {Swiper as SwiperClass, Scrollbar, Navigation} from 'swiper/swiper.esm.js'
// import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// // Swiper modules
// SwiperClass.use([Scrollbar, Navigation])
// // local component
// const {directive} = getAwesomeSwiper(SwiperClass)

export default {
	deactivated: {
		clickOutside
	},
	// directives: {
	// 	swiper: directive
	// },
	props: [
		'emoticonList',
	],
	data() {
		return {
			result: [],
			callLocation: null,
			comment: null,
			selected: null,
			type: null,
			float: false,
			location: {
				top: 0,
				left: 0,
			},
			hiddenFlag: true,
			resizeLayer: false,
			// swiperOption: {
			// 	slidesPerView: 5,
			// 	spaceBetween: 5,
			// 	navigation: {
			// 		nextEl: '.swiper-button-next',
			// 		prevEl: '.swiper-button-prev'
			// 	}
			// },
			// selectedCat: null,
			// selectedList: null,
			isIE: [ false ],
			txtAddEmoticon: false,
			commentId: ""
		}
	},
	created() {
		this.CHECK_IE({res: this.isIE});
	},
	watch: {
		float() {
			let vue = document.getElementById("board-emoticon-selector");
			if (this.float) {
				// 이모티콘 선택 레이어 show (data set, 화면 표시)
				this.result = this.callLocation === 'brdCommentEmoticon' ? this.emoticonList.brdCommentEmoticon : this.emoticonList.decisionEmoticon;
				this.hiddenFlag = false;// vue.classList.remove('hidden')
			}else {
				// 이모티콘 선택 레이어 hide (data reset, 화면 숨김)
				document.body.classList.remove('prevent-emoticon-layer-scroll');
				let scrollBox = document.getElementById('boardCmtScrollBox');
				if(scrollBox !== null) scrollBox.classList.remove('prevent-emoticon-layer-scroll');
				this.activeClass(null);
				this.init();
				this.location.top = 0;
				this.location.left = 0;
				this.disableActiveClass();
				this.hiddenFlag = true; // vue.classList.add('hidden');
				this.resizeLayer = false;
			}
		},
		// selectedCat() {
		// 	this.selectedList = null;
		// 	for(var i=0; i<this.result.catEmoticonList.length; i++) {
		// 		let item = this.result.catEmoticonList[i];
		// 		if (item.category.CATEGORY_ID === this.selectedCat.CATEGORY_ID) {
		// 			this.selectedList = item[item.category.CATEGORY_ID];
		// 			break;
		// 		}
		// 	}
		// }
	},
	computed: {
		// swiper() {
		// 	return this.$refs.myEMSwiper.swiper;
		// }
		hasEmoticon:function(){
			return document.querySelector(".textarea.addtest")
		}

	},
	methods: {
		...mapActions("coworkUtils", ["CHECK_IE"]),

		init() {
			this.selected = null;
			this.comment = null;
			this.callLocation = null;
			this.result = [];
		},
		toggleEmoticonSelect(type, item, comment, event) {
			this.type = type; // regist, modify
			this.callLocation = item;
			this.comment = comment == null ? null : comment;
			let layer = document.getElementById("board-emoticon-selector");
			if(this.type == 'add' || this.type == 'addUpdate' || this.type == 'addReply'){
				this.txtAddEmoticon = true;
			}else{
				this.txtAddEmoticon = false;
			}
			if(layer.classList.length > 0) {
				if(layer.classList.contains('hidden')) {
					// 레이어 위치 조정
					let resize = false;
					let clickEvent = event.target.getBoundingClientRect();
					let scroll = this.isIE ? (window.scrollY || window.pageYOffset) : 0;
					if (item === 'brdCommentEmoticon') {
						document.body.classList.add('prevent-emoticon-layer-scroll');
						let scrollBox = document.getElementById('boardCmtScrollBox');
						scrollBox.classList.add('prevent-emoticon-layer-scroll');

						// this.resizeLayer: true ? height: 350px
						// this.resizeLayer: false ? height: 426px
						let top = 0;
						let topHeight = clickEvent.top; /* 버튼 기준으로 상단 사이즈 = 버튼 위치 */
						let downHeight = clickEvent.top + 10; /* 버튼 기준으로 하단 사이즈 = 화면 사이즈 - 버튼 위치 - 버튼 크기 */

						let showTop = function(resize) {
							let location = topHeight - 10;
							location = !resize ? (location - 417) : (location - 350);
							return location;
						}
						let showDown = downHeight + 13;

						// 경우의 수 1. 426 <= 상단 사이즈
						// 경우의 수 2. 426 > 상단 사이즈
						if (426 <= topHeight) {
							top = showTop(resize);
						}
						else {
							// 경우의 수 3. 350 <= 상단 사이즈
							// 경우의 수 4. 350 > 상단 사이즈
							if (350 <= topHeight) {
								resize = true;
								top = showTop(resize);
							}else {
								// 경우의 수 5. 426 <= 하단 사이즈
								// 경우의 수 6. 426 > 하단 사이즈
								topHeight = document.body.offsetHeight - topHeight;
								downHeight = document.body.clientHeight - downHeight;
								if (426 <= downHeight) {
									top = showDown;
								}
								else {
									// 경우의 수 7: 350 <= 하단 사이즈
									// 경우의 수 8: 350 > 하단 사이즈
									// 경우의 수 9: 368 < 하단 사이즈
									if ((350 <= downHeight) && downHeight < 368) {
										resize = true;
										top = showDown;
									}else if (downHeight < 350) {
										// console.log("## 케이스 체크 필요")
										resize = true;
										top = showTop(resize);
									}else {
										resize = true;
										top = showDown;
									}
								}
							}
						}
						// console.log("### offsetHeight, topHeight ", document.body.offsetHeight + '||' + topHeight)
						// console.log("### clientHeight, downHeight ", document.body.clientHeight + '||' + downHeight)
						this.location.left = clickEvent.left - 350;
						this.location.top = top;
					}else if (item === 'decisionEmoticon') {
						this.location.left = clickEvent.left;
						this.location.top = clickEvent.top - 427;
					}
					this.float = true;
					this.resizeLayer = resize;
				}else {
					this.float = false;
					this.resizeLayer = false;
				}
			}
		},
		toggleEmoticonSelectUpdate(type, item, comment,commentId, event) {
			this.commentId  = commentId;
			this.type = type; // regist, modify
			this.callLocation = item;
			this.comment = comment == null ? null : comment;
			let layer = document.getElementById("board-emoticon-selector");
			this.txtAddEmoticon = true;

			if(layer.classList.length > 0) {
				if(layer.classList.contains('hidden')) {
					// 레이어 위치 조정
					let resize = false;
					let clickEvent = event.target.getBoundingClientRect();
					let scroll = this.isIE ? (window.scrollY || window.pageYOffset) : 0;
					if (item === 'brdCommentEmoticon') {
						document.body.classList.add('prevent-emoticon-layer-scroll');
						let scrollBox = document.getElementById('boardCmtScrollBox');
						scrollBox.classList.add('prevent-emoticon-layer-scroll');

						let top = 0;
						let topHeight = clickEvent.top; /* 버튼 기준으로 상단 사이즈 = 버튼 위치 */
						let downHeight = clickEvent.top + 10; /* 버튼 기준으로 하단 사이즈 = 화면 사이즈 - 버튼 위치 - 버튼 크기 */

						let showTop = function(resize) {
							let location = topHeight - 10;
							location = !resize ? (location - 417) : (location - 350);
							return location;
						}
						let showDown = downHeight + 13;

						if (426 <= topHeight) {
							top = showTop(resize);
						}
						else {
							if (350 <= topHeight) {
								resize = true;
								top = showTop(resize);
							}else {
								topHeight = document.body.offsetHeight - topHeight;
								downHeight = document.body.clientHeight - downHeight;
								if (426 <= downHeight) {
									top = showDown;
								}
								else {
									if ((350 <= downHeight) && downHeight < 368) {
										resize = true;
										top = showDown;
									}else if (downHeight < 350) {
										resize = true;
										top = showTop(resize);
									}else {
										resize = true;
										top = showDown;
									}
								}
							}
						}
						this.location.left = clickEvent.left - 350;
						this.location.top = top;
					}else if (item === 'decisionEmoticon') {
						this.location.left = clickEvent.left;
						this.location.top = clickEvent.top - 427;
					}
					this.float = true;
					this.resizeLayer = resize;
				}else {
					this.float = false;
					this.resizeLayer = false;
				}
			}
		},
		/* 이모티콘 선택 시 이벤트 */
		onSelectImage(item) {
			this.activeClass(item);
			this.selected = item;
		},
		/* 이모티콘 레이어에서 이모티콘 클릭 시, 선택 활성화 이벤트 */
		activeClass(selectedItem) {
			let list = this.result.allEmoticonList;
			// let list = this.selectedCat === null ? this.result.allEmoticonList : this.selectedList;

			// li --selected 초기화
			for(let i=0; i<list.length; i++) {
				let li = document.getElementById(list[i].emoticonId);
				li.classList.contains('selected') ? li.classList.remove('selected') : '';
			}

			// li --selected 설정
			if (selectedItem != null) {
				let li = document.getElementById(selectedItem.emoticonId);
				li.classList.add('selected');
			}
		},
		/* 이모티콘 아이콘 비활성화 */
		disableActiveClass() {
			let icons = document.getElementsByClassName('btn-emoticon');
			if(icons !== null) {
				for(let i=0; i<icons.length; i++) {
					if (icons[i].classList.contains('active')) icons[i].classList.remove('active');
				}
			}
		},
		/* [취소] 버튼 이벤트: 레이어 창 닫기 */
		cancel() {
			if(this.txtAddEmoticon){
				this.txtAddEmoticon = false;
			}
			this.toggleEmoticonSelect(this.callLocation, this.comment == null ? null : this.comment);
		},
		/* [등록] 버튼 이벤트: 선택한 이모티콘 등록 */
		regist() {
			let item = this.selected;
			if(item != null) {
				let payload = {
					comment: this.comment,
					item: item,
					type: this.type
				};
				EventBus.$emit(this.callLocation, payload);
				this.cancel();
			}
		},
		/* [추가] 버튼 이벤트: 선택한 이모티콘 텍스트박스에 추가 */
		add() {
			let el = document.createElement('img');
			el.setAttribute('src', this.$emoticonFn.getEmoticonaddImg(this.selected.tenantId, this.selected.select));
			el.setAttribute('class', 'txtAddEmoticon');
			el.setAttribute('style', 'vertical-align: bottom;');

			if(this.type =='add'){
				if(document.querySelector(".textarea.txtEmoticonAdd").lastChild.tagName) {
					document.querySelector(".textarea.txtEmoticonAdd").lastChild.appendChild(el);
				} else {
					document.querySelector(".textarea.txtEmoticonAdd").appendChild(el);
				}
				document.querySelector(".txtEmoticon").classList.add('hide')
			}else if(this.type == 'addReply'){
				if(document.querySelector(".textarea.editor"+this.commentId).lastChild.tagName) {
					document.querySelector(".textarea.editor"+this.commentId).lastChild.appendChild(el);
				} else {
					document.querySelector(".textarea.editor"+this.commentId).appendChild(el);
				}
				document.querySelector(".txtReplyEmoticon" + this.commentId).classList.add('hide');
			}


			let item = this.selected;
			if(item != null) {
				let payload = {
					comment: this.comment,
					item: item,
					type: this.type
				};
				EventBus.$emit(this.callLocation, payload);
				this.txtAddEmoticon = false;
				this.cancel();
			}
		},
		/* [수정] 버튼 이벤트: 선택한 이모티콘 텍스트박스에 추가 */
		addUpdate() {
			let el = document.createElement('img');
			el.setAttribute('src', this.$emoticonFn.getEmoticonaddImg(this.selected.tenantId, this.selected.select));
			el.setAttribute('class', 'txtAddEmoticon');
			el.setAttribute('style', 'vertical-align: bottom;');

			if(this.type == 'addUpdate'){
				if(document.querySelector(".textarea.emoUpdate"+this.commentId).lastChild.tagName) {
					document.querySelector(".textarea.emoUpdate"+this.commentId).lastChild.appendChild(el);
				} else {
					document.querySelector(".textarea.emoUpdate"+this.commentId).appendChild(el);
				}
				document.querySelector(".txtEmoticonUpdate" + this.commentId).classList.add('hide');

			}else{
				if(document.querySelector(".textarea.editor.reply.ediEmo"+this.commentId).lastChild.tagName) {
					document.querySelector(".textarea.editor.reply.ediEmo"+this.commentId).lastChild.appendChild(el);
				} else {
					document.querySelector(".textarea.editor.reply.ediEmo"+this.commentId).appendChild(el);
				}
				document.querySelector(".replyEmoticonUpdate" + this.commentId).classList.add('hide');
			}

			let item = this.selected;
			if(item != null) {
				let payload = {
					comment: this.comment,
					item: item,
					type: this.type
				};
				EventBus.$emit(this.callLocation, payload);
				this.txtAddEmoticon = false;
				this.cancel();
			}
		},
		/* 이모티콘 더블 클릭 이벤트: 이모티콘 바로 등록 */
		registDblclick(item) {
			this.activeClass(item);
			this.selected = item;
			if(this.txtAddEmoticon){
				if(this.type == 'add' || this.type == 'addReply'){
					this.add();
				}else{
					this.addUpdate();
				}
			}else{
				this.regist();
			}
						
		},
		/* 이모티콘 레이어 외부 클릭 시, 레이어 창 닫김 */
		onClickOutside (event) {
			if(!this.float && event.target.classList.contains('btn-emoticon')) {
				return ;
			}else if(this.float && !event.target.classList.contains('btn-emoticon')) {
				this.cancel();
			}
		},
	}
}
</script>

<style scoped>
	.emoticon-wrap {
		z-index: 999;
	}
</style>


// WEBPACK FOOTER //
// src/components/cowork/common/emoticon/EmoticonSelector.vue